import axios from 'axios';
import Logo from 'jsx:../img/tandem-logo-horizontal.svg';
import { Form, Link, useActionData } from 'react-router-dom';

export async function forgotPasswordAction({ request /*params */ }) {
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	try {
		await axios.post('/coords/reset', data);
	} catch (err) {
		// do nothing. backend returns 404 if email isn't in our system.
	}
	return { submitted: true, ...data };
}

const Login = () => {
	const data = useActionData();
	return (
		<div className="flex flex-col flex-1 min-h-full px-6 pt-16 lg:px-8">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<div className="w-full h-auto">
					<Logo />
				</div>
				{data?.submitted ? (
					<>
						<h1 className="mt-6 leading-9 tracking-tight text-center text-gray-900">
							Check your phone for a text message
						</h1>
						<p className="text-center">
							We have sent a text message to your phone with a link to change
							your password.
						</p>
					</>
				) : (
					<>
						<h1 className="mt-6 leading-9 tracking-tight text-center text-gray-900">
							Forgot password
						</h1>
						<p className="text-center">
							Enter the email you used to create your account so we can send you
							a link via a text message on your phone.
						</p>
					</>
				)}
			</div>

			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				<Form className="space-y-6" method="POST">
					{data?.submitted ? (
						<>
							<p className="text-sm text-center">
								Didn’t receive the text message?
								<input type="hidden" name="email" value={data.email} />
							</p>
							<div>
								{/* <button
									className="text-white btn btn-primary btn-block"
									type="submit"
								>
									Resend Email
								</button> */}
							</div>
							<p>
								Open a ticket with our{' '}
								<a href="mailto:support@nowintandem.com?subject=SDOH%20Forgot%20Password">
									Support Desk
								</a>{' '}
							</p>
						</>
					) : (
						<>
							<div className="form-control">
								<label htmlFor="email" className="label label-text">
									Email address
								</label>
								<input
									id="email"
									name="email"
									type="email"
									autoComplete="email"
									required
									placeholder="example@mail.com"
									className="input input-bordered"
								/>
							</div>

							<div className="form-control">
								<label
									htmlFor="sms-consent"
									className="gap-3 cursor-pointer label"
								>
									<input
										id="sms-consent"
										type="checkbox"
										className="checkbox"
										required
									/>
									<span className="label-text">
										I consent to receive a text message at the phone number
										associated with this account. Message and data rates may
										apply.
									</span>
								</label>
							</div>

							<div>
								<button className="btn btn-primary btn-block" type="submit">
									Send
								</button>
							</div>
						</>
					)}
					<div>
						<Link to="/" className="btn btn-outline btn-block btn-sm">
							Return to Login
						</Link>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default Login;
